import React from "react";
import { Goals } from "../../models/Goals";
import CardCotainer, { Card } from "../../ui-elements/CardContainer/CardContainer";

import workout1 from '../../assets/workout-1.png';
import workout2 from '../../assets/workout-2.png';
import workout3 from '../../assets/workout-3.png';
import workout4 from '../../assets/workout-4.png';
import workout5 from '../../assets/workout-5.png';
import { AnalyticsApi } from "../../api/user";

interface WorkoutProp {
	goal: Goals;
	valueSelected(response?: any): void;
}

const Workout: React.FC<WorkoutProp> = ({ goal, valueSelected }): JSX.Element => {
	const [selectedIndex, setSelectedIndex] = React.useState(typeof goal.workout !== "undefined" ? goal.workout : -1);
	const [enabled, setEnabled] = React.useState(false);
	const workouts: Card[] = [
		{
			index: 0,
			imageUrl: workout1,
			title: "Very Light",
			body: "Almost no purposeful exercise.",
		},
		{
			index: 1,
			imageUrl: workout2,
			title: "Light",
			body: "1-3 hours of gentle to moderate exercise.",
		},
		{
			index: 2,
			imageUrl: workout3,
			title: "Moderate",
			body: "3-4 hours of moderate exercise.",
		},
		{
			index: 3,
			imageUrl: workout4,
			title: "Intense",
			body: "4-6 hours of moderate to strenuous exercise.",
		},
		{
			index: 4,
			imageUrl: workout5,
			title: "Very Intense",
			body: "7+ hours of strenuous exercise.",
		},
	];

	const cardClicked = (index: number) => {
		goal.setWorkout(index);
		setSelectedIndex(index);
		setEnabled(true);
	};

	const valueClicked = () => {
		AnalyticsApi.logEvent('Workout Selected');
		valueSelected();
	};

	React.useEffect(() => {
		if (typeof goal.workout !== "undefined") {
			setEnabled(true);
		}
	}, []);

	return (
		<div className="content">
			<CardCotainer cardList={workouts} selectedIndex={selectedIndex} valueSelected={cardClicked}></CardCotainer>

			<div className="">
				{enabled ? (
					<button className="greenButton" onClick={(e) => valueClicked()}>
						Next
					</button>
				) : (
					<button className="lightGrayButton">Next</button>
				)}
			</div>
		</div>
	);
};

export default Workout;
